import Form, { formCreate } from '@/found/components/form';
import request from '@/found/utils/request';
import CustomerList from './customer-list.vue';
import storeList from './store-list.vue';

formCreate.component('CustomerList', CustomerList);
formCreate.component('storeList', storeList);
export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      rule: [],
      formFunctionCode: 'specialty_store_form',
      formParentCode: 'CRM20250929000000002',
    };
  },

  methods: {
    // 重置规则
    setRule(v) {
      const item = v;
      if (item.field === 'customerName') { // 选择客户
        item.props = {
          ...item.props,
          params: {
            functionCode: 'customer_list',

          },
          getValue: (field) => this.getFieldValue(field),
          title: '客户',
        };
      }
      if (item.field === 'exclusiveShopName') { // 选择客户
        item.props = {
          ...item.props,
          params: {
            functionCode: 'store-list',
            paramData: {
              approveStatus: '3',
            },

          },
          getValue: (field) => this.getFieldValue(field),
          title: '专卖店',
        };
      }
      if (item.field === 'businessArea') {
        item.props = {
          ...item.props,
        };

        item.validate = [
          ...item.validate,
          {
            trigger: 'blur',
            pattern: /^\d+(\.\d+)?$/,
            message: '请输入数字',
          },
        ];
      }
      if (item.field === 'attachVos') {
        item.props = {
          ...item.props,
          showFileList: true,
          uploadType: 'file',
          fileMsg: '只能上传pdf/word/excel/ppt/png/jpg文件',
          accept: '.pdf,.doc,.docx,.xlsx,.xls,.ppt,.pptx,.png,.jpg',
        };
      }
      return v;
    },

    // 获取详情
    async getDetail() {
      request.post('/mdm/mdmexclusiveshopchange/query', { id: this.formConfig.row.id }).then((res) => {
        if (res.success) {
          const { result } = res;
          if (result.changeType === '1') {
            this.hiddenFields(false, ['isAddrChange', 'afterAddress', 'beforeAddress']);
          } else {
            this.hiddenFields(true, ['isAddrChange', 'afterAddress', 'beforeAddress']);
          }
          if (result.isAddrChange === '1') {
            this.hiddenFields(false, ['afterAddress', 'beforeAddress']);
          } else {
            this.hiddenFields(true, ['afterAddress', 'beforeAddress']);
          }
          this.setValue({
            ...result,
          });
          //   setTimeout(() => {
          //     if (result.isAddrChange) {
          //       this.hiddenFields(false, ['isAddrChange']);
          //     } else {
          //       this.hiddenFields(true, ['isAddrChange']);
          //     }
          //     if (result.afterAddress) {
          //       this.hiddenFields(false, ['afterAddress']);
          //     } else {
          //       this.hiddenFields(true, ['afterAddress']);
          //     }
          //     if (result.beforeAddress) {
          //       this.hiddenFields(false, ['beforeAddress']);
          //       this.disabled(true, ['beforeAddress']);
          //     } else {
          //       this.hiddenFields(true, ['beforeAddress']);
          //       this.disabled(false, ['beforeAddress']);
          //     }
          //     if (result.beforeLevel) {
          //       this.disabled(true, ['beforeLevel']);
          //     } else {
          //       this.disabled(false, ['beforeLevel']);
          //     }

        //     this.setValue({
        //       ...result,
        //     });
        //   }, 100);
        }
      });
    },

    // 完成渲染
    formComplete() {
      this.hiddenFields(true, ['isAddrChange', 'afterAddress', 'beforeAddress']);
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      this.setValue({
        responsibleUserCode: userInfo.userName,
        responsibleUserName: userInfo.fullName,
        responsibleOrgCode: userInfo.orgCode,
        responsibleOrgName: userInfo.orgName,
      });

      // 专卖店
      const exclusiveShopName = this.getRule('exclusiveShopName');
      exclusiveShopName.on.change = (e) => {
        if (e) {
        //   if (e[0].level) {
        //     this.disabled(true, ['beforeLevel']);
        //   } else {
        //     this.disabled(false, ['beforeLevel']);
        //   }
        //   if (e[0].address) {
        //     this.disabled(true, ['beforeAddress']);
        //   } else {
        //     this.disabled(false, ['beforeAddress']);
        //   }
          this.setValue({
            exclusiveShopName: e[0].exclusiveShopName,
            exclusiveShopCode: e[0].exclusiveShopCode,
            beforeLevel: e[0].level,
            beforeAddress: e[0].address,
          });
        } else {
          this.setValue({
            exclusiveShopName: null,
            exclusiveShopCode: null,
          });
        }
      };
      // 经销商
      const customerName = this.getRule('customerName');
      customerName.on.change = (e) => {
        if (e) {
          this.setValue({
            customerName: e[0].customerName,
            customerCode: e[0].customerCode,
          });
        } else {
          this.setValue({
            customerName: null,
            customerCode: null,
          });
        }
      };
      // 变更类型
      const changeType = this.getRule('changeType');
      changeType.on.change = (e) => {
        if (e === '1') {
          this.hiddenFields(false, ['isAddrChange', 'afterAddress', 'beforeAddress']);
        } else {
          this.hiddenFields(true, ['isAddrChange', 'afterAddress', 'beforeAddress']);
          this.setValue({
            beforeAddress: null,
            afterAddress: null,
            isAddrChange: '0',
          });
        }
      };
      const isAddrChange = this.getRule('isAddrChange');
      isAddrChange.on.change = (e) => {
        if (e === '1') {
          this.hiddenFields(false, ['afterAddress', 'beforeAddress']);
        } else {
          this.hiddenFields(true, ['afterAddress', 'beforeAddress']);
          this.setValue({
            beforeAddress: null,
            afterAddress: null,
          });
        }
      };
      if (this.formConfig.code === 'view' || this.formConfig.code === 'edit') {
        this.getDetail(this.formConfig.row.id);
      }
    },

    // 提交
    submit() {
      const formData = this.getFormData();
      console.log('formData', formData);
      if (formData) {
        let url = '/mdm/mdmexclusiveshopchange/save';
        // 有id  就是编辑
        if (this.formConfig.code === 'edit') {
          formData.id = this.formConfig.row.id;
          url = '/mdm/mdmexclusiveshopchange/update';
        }
        if (formData.applyDate) {
          formData.applyDate = `${formData.applyDate} 00:00:00`;
        }
        request.post(url, formData).then((res) => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '操作成功',
            });
            this.$emit('onClose');
            this.$emit('onGetList');
          }
        });
      }
    },
  },
};
